import { marketingAdministratorRoles } from "../../config/roles";
import { PageAction } from "../recordDefinition.types";

export const communicationActivityPageActions: PageAction[] = [
  {
    id: "resend",
    label: "Resend",
    roles: marketingAdministratorRoles,
    // Only a completed send has anything to send again.
    visible: (record) => Boolean(record.id) && record.statecode === 1,
    run: async (record, dispatch) => {
      // Loaded on demand, so the page bar doesn't pull the service layer in behind it.
      const { ResendCommunicationActivity } = await import("../../api/communicationService");
      const response = await ResendCommunicationActivity(
        dispatch,
        record.id,
        record.g4c_communication
      );

      return response?.status === 200 ? "Communication resent" : undefined;
    },
  },
];
